module.exports = __webpack_public_path__ + "img/EnvironmentChecked.07f8d051.svg";